import type { JobBoardName } from './types';

export const JOB_BOARD_NAME: JobBoardName = 'oura';
